module.exports = __webpack_public_path__ + "static/pic03-43dc69591a80d7cba6cc26c0d7e0cff8.jpg";